import axios from '@/axios'
import API from '@/API'

const PREFIX = 'menu'

export default {
  all() {
    return axios.get(`${API.endpoint}/${PREFIX}`)
  },
  navbar() {
    return axios.get(`${API.endpoint}/${PREFIX}/navbar`)
  },
  parents() {
    return axios.get(`${API.endpoint}/${PREFIX}/parent`)
  },
  positions(parent, params) {
    return axios.get(`${API.endpoint}/${PREFIX}/position/${parent}`, {
      params: params
    })
  },
  datatable(params) {
    return axios.get(`${API.endpoint}/${PREFIX}/datatable`, {
      params: params
    })
  },
  detail(id) {
    return axios.get(`${API.endpoint}/${PREFIX}/detail/${id}`)
  },
  store(data) {
    return axios.post(`${API.endpoint}/${PREFIX}/add`, data)
  },
  update(id, data) {
    return axios.post(`${API.endpoint}/${PREFIX}/update/${id}`, data)
  },
  delete(id) {
    return axios.post(`${API.endpoint}/${PREFIX}/delete/${id}`)
  }
}